var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVsCode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Visual Studio Code 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.10564 10.2266C2.10564 10.2266 1.50756 9.79542 2.22548 9.21974L3.89764 7.72454C3.89764 7.72454 4.37588 7.22166 4.88212 7.65958L20.3112 19.3412V24.9423C20.3112 24.9423 20.3034 25.8215 19.1756 25.7252L2.10564 10.2266Z",
    fill: "#2489CA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.08152 13.8376L2.10552 17.453C2.10552 17.453 1.69672 17.7565 2.10552 18.2997L3.9524 19.9786C3.9524 19.9786 4.39144 20.449 5.0388 19.9136L9.25448 16.7172L6.08152 13.8376Z",
    fill: "#1070B3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.0637 13.8678L20.3571 8.29916L20.3101 2.72716C20.3101 2.72716 19.9987 1.51084 18.9593 2.14364L9.25342 10.9771L13.0637 13.8678Z",
    fill: "#0877B9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M19.1734 25.733C19.5968 26.1664 20.1108 26.0242 20.1108 26.0242L25.7948 23.2231C26.5228 22.7269 26.4198 22.112 26.4198 22.112V5.3882C26.4198 4.65348 25.6672 4.39924 25.6672 4.39924L20.7414 2.02484C19.6651 1.35956 18.9595 2.14468 18.9595 2.14468C18.9595 2.14468 19.8667 1.49172 20.3102 2.7282V24.8415C20.3102 24.9938 20.2777 25.1428 20.2128 25.2772C20.0828 25.5392 19.8017 25.7834 19.1264 25.6804L19.1734 25.733Z",
    fill: "#3C99D4"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVsCode);
export default __webpack_public_path__ + "static/media/VS_code.d22b6461ced4b96311693ab54d34c565.svg";
export { ForwardRef as ReactComponent };